import React, { FC, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";

const Services: FC = () => {
  const [selectedButton, setSelectedButton] = useState<
    "user" | "company" | "university"
  >("company");
  const navigate = useNavigate();
  const [isOpenFor, setisOpenFor] = useState<"all" | "none">("none");
  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const renderContent = () => {
    switch (selectedButton) {
      case "user":
        return (
          <div className="text-center">
            <Button
              size="lg"
              onClick={() => handleNavigation("/register?isJobseeker=true")}
            >
              I am looking for a Job
            </Button>
          </div>
        );
      case "company":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <CompanyCard
              title="Post your jobs where candidates can see them"
              description="Onboard on Dhoondh and get access to white-collar candidate pool and application management."
              price="FREE"
              features={[
                "Self-manage company profile and job postings",
                "Automated application management",
                "No dedicated support",
                "Suitable for basic hiring needs",
              ]}
              onClick={() => handleNavigation("/register?isCompany=true")}
            />
            <CompanyCard
              title="Priority Fulfilment."
              description="Need staff urgently? Positions filled in 3–10 days with end-to-end management for ₹7,499."
              price="₹7,499 (Urgent Hiring)"
              features={[
                "Priority hiring for urgent requirements",
                "Positions fulfilled within 3–10 working days",
                "End-to-end hiring assistance included",
              ]}
              onClick={() => setisOpenFor("all")}
            />
          </div>
        );
      case "university":
        return (
          <>
            <UniversityHeroSection />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <UniversityCard
                title="The Internship Gateway"
                subTitle="No-Cost Initiative"
                description="We support your 3rd and 4th-year students in fulfilling their mandatory internship requirements."
                features={[
                  "Zero Cost: No fees for the University, companies, or students.",
                  "Streamlined Coordination: We manage industry outreach and student mapping.",
                  "Flexibility: Tailored on-campus or off-campus drives to suit your calendar.",
                ]}
                onClick={() => handleNavigation("/contact")}
              />
              <UniversityCard
                title="The Placement Module"
                subTitle="Outcome-Driven"
                description="Take your placement statistics to the next level with our structured execution framework."
                features={[
                  "Nominal Fee: Only ₹149 per student for a complete placement drive cycle.",
                  "Transparent Reporting: Receive a Placement Drive Report of the student body.",
                  "Skill Gap Analysis: (Optional) Deep-dive insights into student performance and a comprehensive report at additional cost to analyse student skill gap.",
                ]}
                onClick={() => handleNavigation("/contact")}
              />
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-primary-teaGreen/5 to-white">
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-20 md:pt-24 pb-16">
        {/* Background decorations */}
        <div className="absolute -top-20 -right-20 h-64 w-64 md:h-96 md:w-96 rounded-full bg-primary-teaGreen/20 blur-3xl animate-pulse" />
        <div className="absolute -bottom-16 -left-16 h-64 w-64 md:h-96 md:w-96 rounded-full bg-primary-lightGreen/15 blur-3xl animate-pulse" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight text-primary-black mb-6 leading-tight">
              Our <span className="text-primary-lightGreen">Services</span>
            </h1>
            <p className="text-lg md:text-xl lg:text-2xl text-gray-600 mb-12 max-w-4xl mx-auto leading-relaxed">
              Whether you're looking for your next opportunity or building your
              dream team, we have the perfect solution for you.
            </p>
          </div>
          <div className="flex flex-col md:flex-row justify-center gap-4">
            <Button
              variant={selectedButton === "user" ? "primary" : "outline"}
              onClick={() => {
                setSelectedButton("user");
                handleNavigation("/register?isJobseeker=true");
              }}
            >
              I am looking for a Job
            </Button>
            <Button
              variant={selectedButton === "company" ? "primary" : "outline"}
              onClick={() => setSelectedButton("company")}
            >
              I am looking to Hire
            </Button>
            <Button
              variant={selectedButton === "university" ? "primary" : "outline"}
              onClick={() => setSelectedButton("university")}
            >
              I am looking for Placement
            </Button>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-14">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {renderContent()}
        </div>
      </section>
      <Modal
        isOpen={isOpenFor != "none"}
        onClose={() => {
          setisOpenFor("none");
        }}
        title="Please Select Prefered Method"
        size="sm"
      >
        <div className="flex flex-col justify-center gap-4">
          <Button
            variant={"primary"}
            onClick={() => handleNavigation("/register?isCompany=true")}
          >
            Sign Up
          </Button>
          <Button
            variant={'secondary'}
            onClick={() => handleNavigation("/contact")}
          >
            Contact Us Via Email
          </Button>
          {(isOpenFor == "all") && (
            <Button
              variant={'secondary'}
              onClick={() => {
                var url = "https://wa.me/919316846322";
                // Open the URL in a new tab/window
                var newTab = window.open(url, "_blank");
                // Optional: focus the new tab
                if (newTab) {
                  newTab.focus();
                }
              }}
            >
              Contact Us Via Whatsapp
              <svg
                className="pl-2 h-6 w-6"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20.52 3.48A11.94 11.94 0 0012.06.03C5.64.03.45 5.22.45 11.64c0 2.05.54 4.05 1.57 5.82L.02 24l6.69-2.02a11.7 11.7 0 005.35 1.34h.01c6.43 0 11.62-5.19 11.62-11.61 0-3.1-1.21-6.02-3.17-8.23zM12.07 21.2h-.01a9.55 9.55 0 01-4.86-1.31l-.35-.2-3.97 1.2 1.18-3.86-.23-.36a9.6 9.6 0 01-1.45-5.23C2.38 6.41 6.45 2.34 12.06 2.34c2.57 0 4.98 1 6.8 2.82a9.53 9.53 0 012.8 6.78c0 5.61-4.57 10.26-10.59 9.26z" />
                <path d="M17.16 14.22c-.29-.14-1.72-.85-1.98-.95-.27-.1-.47-.14-.67.14-.2.29-.77.95-.94 1.15-.17.19-.35.21-.64.07-.29-.14-1.22-.45-2.33-1.44-.86-.77-1.44-1.72-1.6-2.01-.17-.29-.02-.45.12-.59.12-.12.29-.31.43-.46.15-.15.19-.26.29-.43.1-.19.05-.34-.02-.48-.07-.14-.67-1.62-.92-2.21-.24-.58-.48-.5-.67-.5l-.57-.01c-.2 0-.48.07-.73.34-.25.26-.96.94-.96 2.29s.98 2.66 1.12 2.85c.14.19 1.92 2.94 4.65 4.13.65.28 1.16.44 1.56.56.65.21 1.24.18 1.7.11.52-.08 1.72-.7 1.97-1.37.24-.67.24-1.23.17-1.37-.07-.14-.26-.22-.55-.36z" />
              </svg>
            </Button>
          )}

          {(isOpenFor == "all") && (
            <Button
              variant={'secondary'}
              onClick={() => {
                var url = "https://wa.me/919316846322";
                // Open the URL in a new tab/window
                var newTab = window.open(url, "_blank");
                // Optional: focus the new tab
                if (newTab) {
                  newTab.focus();
                }
              }}
            >
              <p className="block md:inline">
                <span className="block md:inline">Contact Us Via Whatsapp </span>
                <span className="block md:inline"> (Blue collar) </span>
              </p>
              <svg
                className="pl-2 h-6 w-6"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20.52 3.48A11.94 11.94 0 0012.06.03C5.64.03.45 5.22.45 11.64c0 2.05.54 4.05 1.57 5.82L.02 24l6.69-2.02a11.7 11.7 0 005.35 1.34h.01c6.43 0 11.62-5.19 11.62-11.61 0-3.1-1.21-6.02-3.17-8.23zM12.07 21.2h-.01a9.55 9.55 0 01-4.86-1.31l-.35-.2-3.97 1.2 1.18-3.86-.23-.36a9.6 9.6 0 01-1.45-5.23C2.38 6.41 6.45 2.34 12.06 2.34c2.57 0 4.98 1 6.8 2.82a9.53 9.53 0 012.8 6.78c0 5.61-4.57 10.26-10.59 9.26z" />
                <path d="M17.16 14.22c-.29-.14-1.72-.85-1.98-.95-.27-.1-.47-.14-.67.14-.2.29-.77.95-.94 1.15-.17.19-.35.21-.64.07-.29-.14-1.22-.45-2.33-1.44-.86-.77-1.44-1.72-1.6-2.01-.17-.29-.02-.45.12-.59.12-.12.29-.31.43-.46.15-.15.19-.26.29-.43.1-.19.05-.34-.02-.48-.07-.14-.67-1.62-.92-2.21-.24-.58-.48-.5-.67-.5l-.57-.01c-.2 0-.48.07-.73.34-.25.26-.96.94-.96 2.29s.98 2.66 1.12 2.85c.14.19 1.92 2.94 4.65 4.13.65.28 1.16.44 1.56.56.65.21 1.24.18 1.7.11.52-.08 1.72-.7 1.97-1.37.24-.67.24-1.23.17-1.37-.07-.14-.26-.22-.55-.36z" />
              </svg>
            </Button>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default Services;

const UniversityHeroSection = () => {
  return (
    <div className="text-center pb-16">
      <p className="text-2lg sm:text-3xl md:text-4xl font-extrabold tracking-tight text-primary-black mb-6 leading-tight">
        Empowering the Next Generation of Industry-Ready Professionals
      </p>
      <p className="text-lg md:text-xl lg:text-2xl text-gray-600 mb-6 max-w-4xl mx-auto leading-relaxed">
        Bridging the gap between academia and the professional world through
        structured internships and outcome-driven placements.
      </p>
      <p className="text-lg md:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
        At Dhoondh, we partner with universities to simplify the transition from
        classroom to career. Our Placement-X module is designed to reduce
        administrative friction while maximizing student exposure to verified,
        high-growth industries.
      </p>
    </div>
  );
};

interface CompanyCardProps {
  title: string;
  description: string;
  price: string;
  features: string[];
  onClick: () => void;
}

const CompanyCard: FC<CompanyCardProps> = ({
  title,
  description,
  price,
  features,
  onClick,
}) => {
  return (
    <div className="group cursor-pointer h-full" onClick={onClick}>
      <div className="relative flex flex-col bg-white/90 backdrop-blur border border-gray-100 rounded-3xl p-8 md:p-12 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-4 hover:scale-[1.02] h-full">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-lightGreen/10 to-primary-teaGreen/20 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        <div className="relative z-10 flex flex-1 flex-col">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-black mb-4 group-hover:text-primary-lightGreen transition-colors duration-300">
            {title}
          </h2>
          <p className="text-lg text-gray-600 mb-6 leading-relaxed">
            {description}
          </p>
          <p className="text-lg text-gray-600 mb-6 leading-relaxed font-bold">
            {price}
          </p>
          <ul className="space-y-3 mb-8 flex-1">
            {features.map((feature, index) => (
              <li key={index} className="flex items-center text-gray-700">
                <svg
                  className="w-5 h-5 text-primary-lightGreen mr-3 flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
          <div className="flex items-center text-primary-lightGreen group-hover:text-primary-black transition-colors duration-300">
            <span className="mr-2 font-semibold">Get Started</span>
            <svg
              className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

interface UniversityCardProps {
  title: string;
  subTitle: string;
  description: string;
  features: string[];
  onClick: () => void;
}

const UniversityCard: FC<UniversityCardProps> = ({
  title,
  subTitle,
  description,
  features,
  onClick,
}) => {
  return (
    <div className="group cursor-pointer h-full" onClick={onClick}>
      <div className="relative flex flex-col bg-white/90 backdrop-blur border border-gray-100 rounded-3xl p-8 md:p-12 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-4 hover:scale-[1.02] h-full">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-lightGreen/10 to-primary-teaGreen/20 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        <div className="relative z-10 flex flex-1 flex-col">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-black mb-4 group-hover:text-primary-lightGreen transition-colors duration-300">
            {title}
          </h2>
          <h3 className="text-xl font-bold text-gray-800 mb-4">{subTitle}</h3>
          <p className="text-lg text-gray-600 mb-6 leading-relaxed">
            {description}
          </p>
          <ul className="space-y-3 mb-8 flex-1">
            {features.map((feature, index) => (
              <li key={index} className="flex items-center text-gray-700">
                <svg
                  className="w-5 h-5 text-primary-lightGreen mr-3 flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
          <div className="flex items-center text-primary-lightGreen group-hover:text-primary-black transition-colors duration-300">
            <span className="mr-2 font-semibold">Contact Us</span>
            <svg
              className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};
